module.exports = __webpack_public_path__ + "img/OYF-cta.ae9f200d.png";